import React from 'react';
import ServicesPortfolio from '../components/ServicesPortfolio';

const PortfolioPage = () => {
  return <ServicesPortfolio />;
};

export default PortfolioPage;

